export const phoneCountryPrefixCorrection = (value?: string) =>
  value && value?.length <= 10 && !/\+7|\+|7/.test(value)
    ? `+7${value}`
    : value;
